export const VIEW_TYPES = {
  LIST: 'list',
  CATEGORY: 'category',
};
